var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34458 18.6554C4.88514 18.1959 4.88514 17.451 5.34458 16.9916L10.336 12L5.34458 7.00845C4.88514 6.54899 4.88514 5.80405 5.34458 5.34459C5.80403 4.88514 6.54893 4.88514 7.00838 5.34459L12 10.3364L16.9916 5.34459C17.4511 4.88514 18.196 4.88514 18.6554 5.34459C19.1149 5.80405 19.1149 6.54899 18.6554 7.00845L13.6636 12L18.6554 16.9916C19.1149 17.451 19.1149 18.1959 18.6554 18.6554C18.196 19.1149 17.4511 19.1149 16.9916 18.6554L12 13.6636L7.00838 18.6554C6.54893 19.1149 5.80403 19.1149 5.34458 18.6554Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX2);
export default __webpack_public_path__ + "static/media/CloseX2.8a477d873d16f3d14a1eaaeea55a84ee.svg";
export { ForwardRef as ReactComponent };